import { Box } from "@material-ui/core";
import { useMemo } from "react";
import { FS } from "src/config/constants";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import useLowerAddressParam from "src/hooks/useLowerAddressParam";
import PoolInfo from "../PoolInfo";
import AssetList from "./AssetList";

export default function Overview() {
  const { pool } = useLowerAddressParam();
  const { data, fetchingDataStatus } = usePoolMonitoringContext();
  const tokenList = useMemo(() => {
    if (fetchingDataStatus === FS.SUCCESS && data && Object.entries(data).length > 0 && pool) {
      return data[pool]?.tokens;
    }
    return [];
  }, [data, fetchingDataStatus, pool]);

  return (
    <>
      <PoolInfo />
      <Box mt={5}>
        <AssetList tokenList={tokenList} />
      </Box>
    </>
  );
}
